module.exports = __webpack_public_path__ + "static/homepage-img-57e4b7287daeb27e04c1d76eddcd45d5.png";